import { BarcodeDetector } from "barcode-detector";
export default {
    beforeMount() {
        const windowWithBarcodeDetector = window;
        windowWithBarcodeDetector.BarcodeDetector = BarcodeDetector;
        // }
    },
    methods: {
        async onDetect(resultPromise) {
            this.$emit("detect", resultPromise);
            try {
                const { content } = await resultPromise;
                if (content !== null) {
                    this.$emit("decode", content);
                }
            }
            catch (error) {
                // fail silently
            }
        },
    },
};
